import React from 'react';

// ai icons
import {
  AiFillShop,
  AiOutlineApartment,
  AiOutlineAreaChart,
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineBell,
  AiOutlineCheck,
  AiOutlineCloudDownload,
  AiOutlineCloudSync,
  AiOutlineCloudUpload,
  AiOutlineContacts,
  AiOutlineDashboard,
  AiOutlineDatabase,
  AiOutlineDelete,
  AiOutlineDeliveredProcedure,
  AiOutlineDiff,
  AiOutlineDollar,
  AiOutlineDown,
  AiOutlineDeploymentUnit,
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlineExclamationCircle,
  AiOutlineExport,
  AiOutlineFieldTime,
  AiOutlineFileSync,
  AiOutlineFormatPainter,
  AiOutlineGroup,
  AiOutlineInbox,
  AiOutlineLayout,
  AiOutlineLink,
  AiOutlineLogout,
  AiOutlineMenuFold,
  AiOutlineMinus,
  AiOutlineMinusSquare,
  AiOutlinePhone,
  AiOutlinePicture,
  AiOutlinePlus,
  AiOutlinePlusSquare,
  AiOutlinePullRequest,
  AiOutlineQuestionCircle,
  AiOutlineReconciliation,
  AiOutlineReload,
  AiOutlineRight,
  AiOutlineSave,
  AiOutlineSearch,
  AiOutlineSend,
  AiOutlineShareAlt,
  AiOutlineShopping,
  AiOutlineSolution,
  AiOutlineSound,
  AiOutlineStop,
  AiOutlineTags,
  AiOutlineUp,
  AiOutlineUserSwitch,
  AiOutlineWarning,
} from 'react-icons/ai';
import * as AntdIcon from 'react-icons/ai';

// bi
import {
  BiArrowBack,
  BiEditAlt,
  BiLayerPlus,
  BiSolidCloudUpload,
  BiSolidPhoneCall,
} from 'react-icons/bi';

// bs
import {
  BsArrowDown,
  BsArrowDownUp,
  BsArrowUp,
  BsCheck2,
  BsChevronDown,
  BsChevronUp,
  BsDiagram3,
  BsDot,
  BsPlayCircle,
  BsStopCircle,
  BsToggles,
} from 'react-icons/bs';

// cg
import { CgFormatSlash } from 'react-icons/cg';

// di
import { DiGoogleAnalytics } from 'react-icons/di';

// fa
import {
  FaBan,
  FaCheckCircle,
  FaRegGem,
  FaRegHandPointRight,
  FaRobot,
  FaShoppingCart,
  FaTelegramPlane,
  FaUserAlt,
} from 'react-icons/fa';

// fc
import { FcIdea } from 'react-icons/fc';

// fi
import { FiRefreshCcw, FiUsers } from 'react-icons/fi';

// go
import { GoArchive, GoChecklist, GoFile } from 'react-icons/go';

// hi
import { HiOutlineLockClosed, HiOutlineLockOpen } from 'react-icons/hi';

// im
import { ImFileMusic } from 'react-icons/im';

// io5
import {
  IoArrowRedoOutline,
  IoChatbubblesOutline,
  IoClose,
  IoCloseOutline,
  IoCloseSharp,
  IoTrendingDownOutline,
  IoTrendingUpOutline,
} from 'react-icons/io5';

// ios
import { IoIosArrowBack, IoMdRepeat } from 'react-icons/io';

// lu
import { LuAudioWaveform, LuMousePointerClick } from 'react-icons/lu';

// md
import {
  MdComputer,
  MdContentCopy,
  MdDriveFileMoveOutline,
  MdError,
  MdOutlineCheckBox,
  MdOutlineCheckBoxOutlineBlank,
  MdOutlineManageSearch,
  MdOutlineSettings,
  MdReply,
} from 'react-icons/md';

// ri
import { RiFolderInfoLine } from 'react-icons/ri';

// si
import { SiReactrouter, SiConvertio } from 'react-icons/si';

// tfi
import { TfiShortcode } from 'react-icons/tfi';

// ti
import { TiUpload } from 'react-icons/ti';

// vsc
import { VscGitPullRequestCreate, VscServerProcess } from 'react-icons/vsc';
import { Split } from 'lucide-react';

// gr
import { GrUserSettings } from 'react-icons/gr';

function RefreshFailed(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24' {...props}>
      <path
        fill='currentColor'
        d='M11.29 15.71A1 1 0 0 0 13 15a1.05 1.05 0 0 0-.29-.71a1 1 0 0 0-1.09-.21a1 1 0 0 0-.33.21A1.05 1.05 0 0 0 11 15a1 1 0 0 0 .29.71Zm8.62-.2h-4.53a1 1 0 0 0 0 2h2.4A8 8 0 0 1 4 12a1 1 0 0 0-2 0a10 10 0 0 0 16.88 7.23V21a1 1 0 0 0 2 0v-4.5a1 1 0 0 0-.97-.99ZM12 2a10 10 0 0 0-6.88 2.77V3a1 1 0 0 0-2 0v4.5a1 1 0 0 0 1 1h4.5a1 1 0 0 0 0-2h-2.4A8 8 0 0 1 20 12a1 1 0 0 0 2 0A10 10 0 0 0 12 2Zm0 11a1 1 0 0 0 1-1V9a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1Z'
      ></path>
    </svg>
  );
}

export function AudioSpintax(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 256 256'
      {...props}
    >
      <path
        fill='currentColor'
        d='M96.59 124.91a12 12 0 0 0-13.08 2.6L63 148H44a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h19l20.48 20.48A12 12 0 0 0 104 224v-88a12 12 0 0 0-7.41-11.09M80 195l-3.51-3.52A12 12 0 0 0 68 188H56v-16h12a12 12 0 0 0 8.49-3.51L80 165Zm80-15a44.55 44.55 0 0 1-21.95 38.36A12 12 0 1 1 126 197.64a20.51 20.51 0 0 0 0-35.28a12 12 0 1 1 12.1-20.72A44.55 44.55 0 0 1 160 180m56.49-100.49l-56-56A12 12 0 0 0 152 20H56a20 20 0 0 0-20 20v76a12 12 0 0 0 24 0V44h76v48a12 12 0 0 0 12 12h48v108h-24a12 12 0 0 0 0 24h28a20 20 0 0 0 20-20V88a12 12 0 0 0-3.51-8.49M160 57l23 23h-23Z'
      ></path>
    </svg>
  );
}

export function MoonIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 1024 1024'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M489.493 111.658c30.658-1.792 45.991 36.44 22.59 56.329C457.831 214.095 426 281.423 426 354c0 134.757 109.243 244 244 244c72.577 0 139.905-31.832 186.014-86.084c19.868-23.377 58.064-8.102 56.332 22.53C900.4 745.823 725.141 912 512.5 912C291.31 912 112 732.69 112 511.5c0-211.39 164.287-386.024 374.198-399.649l.206-.013zm-81.143 79.75l-4.112 1.362C271.1 237.943 176 364.092 176 511.5C176 697.344 326.656 848 512.5 848c148.28 0 274.938-96.192 319.453-230.41l.625-1.934l-.11.071c-47.18 29.331-102.126 45.755-159.723 46.26L670 662c-170.104 0-308-137.896-308-308c0-58.595 16.476-114.54 46.273-162.467z'
      ></path>
    </svg>
  );
}

export function SunIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 1024 1024'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M548 818v126c0 8.837-7.163 16-16 16h-40c-8.837 0-16-7.163-16-16V818q23.768 2.464 36 2.464T548 818m205.251-115.66l89.096 89.095c6.248 6.248 6.248 16.38 0 22.627l-28.285 28.285c-6.248 6.248-16.379 6.248-22.627 0L702.34 753.25q18.548-15.064 27.198-23.713q8.649-8.65 23.713-27.198m-482.502 0q15.064 18.548 23.713 27.198q8.65 8.649 27.198 23.713l-89.095 89.096c-6.248 6.248-16.38 6.248-22.627 0l-28.285-28.285c-6.248-6.248-6.248-16.379 0-22.627zM512 278c129.235 0 234 104.765 234 234S641.235 746 512 746S278 641.235 278 512s104.765-234 234-234m0 72c-89.47 0-162 72.53-162 162s72.53 162 162 162s162-72.53 162-162s-72.53-162-162-162M206 476q-2.464 23.768-2.464 36T206 548H80c-8.837 0-16-7.163-16-16v-40c0-8.837 7.163-16 16-16zm738 0c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H818q2.464-23.768 2.464-36T818 476ZM814.062 180.653l28.285 28.285c6.248 6.248 6.248 16.379 0 22.627L753.25 320.66q-15.064-18.548-23.713-27.198q-8.65-8.649-27.198-23.713l89.095-89.096c6.248-6.248 16.38-6.248 22.627 0m-581.497 0l89.095 89.096q-18.548 15.064-27.198 23.713q-8.649 8.65-23.713 27.198l-89.096-89.095c-6.248-6.248-6.248-16.38 0-22.627l28.285-28.285c6.248-6.248 16.379-6.248 22.627 0M532 64c8.837 0 16 7.163 16 16v126q-23.768-2.464-36-2.464T476 206V80c0-8.837 7.163-16 16-16z'
      ></path>
    </svg>
  );
}

const CommonIcons = {
  ...AntdIcon,
  DeleteBulk: AntdIcon.AiOutlineDeleteRow,
  Refresh: AiOutlineReload,
  Edit: BiEditAlt,
  Search: AiOutlineSearch,
  Detail: AiOutlineEye,
  Tooltip: AiOutlineQuestionCircle,
  Upload: AiOutlineCloudUpload,
  FileUpload: TiUpload,
  CloudUpload: BiSolidCloudUpload,
  Download: AiOutlineCloudDownload,
  Plus: AiOutlinePlus,
  Trash: AiOutlineDelete,
  Copy: MdContentCopy,
  File: GoFile,
  Computer: MdComputer,
  FolderMove: IoMdRepeat,
  BoxUnCheck: MdOutlineCheckBoxOutlineBlank,
  BoxChecked: MdOutlineCheckBox,
  User: FaUserAlt,
  ArrowDown: BsChevronDown,
  ArrowUp: BsChevronUp,
  ArrowBack: IoIosArrowBack,
  SortUp: BsArrowUp,
  SortDown: BsArrowDown,
  SortUpDown: BsArrowDownUp,
  Active: BsCheck2,
  InActive: IoClose,
  Deactivate: IoCloseSharp,
  ShoppingCart: FaShoppingCart,
  Back: BiArrowBack,
  Close: IoCloseOutline,
  RightHandPoint: FaRegHandPointRight,

  SignOut: AiOutlineLogout,
  Settings: MdOutlineSettings,
  UserSettings: GrUserSettings,
  Send: AiOutlineSend,

  Homepage: AiOutlineDashboard,
  Inbox: AiOutlineInbox,
  Monitoring: AiOutlineReconciliation,
  Chat: IoChatbubblesOutline,
  Link: AiOutlineLink,
  Contact: AiOutlineContacts,
  Chart: AiOutlineAreaChart,
  Users: FiUsers,
  Share: AiOutlineShareAlt,
  Feedback: AiOutlineSolution,
  Tags: AiOutlineTags,
  Apartment: AiOutlineApartment,
  Phone: AiOutlinePhone,
  Bell: AiOutlineBell,
  Collapse: AiOutlineRight,
  Expand: AiOutlineDown,
  CollapseUp: AiOutlineUp,
  Request: AiOutlinePullRequest,
  Save: AiOutlineSave,
  CloudSync: AiOutlineCloudSync,
  Menu: AiOutlineMenuFold,
  Database: AiOutlineDatabase,
  ToggleSideBar: BsToggles,
  Painter: AiOutlineFormatPainter,
  Layout: AiOutlineLayout,
  ErrorTracker: DiGoogleAnalytics,
  Media: AiOutlinePicture,
  Marketplace: AiFillShop,

  OpenResponder: AiOutlineExport,
  FileOutRight: AiOutlineDeliveredProcedure,
  FileDiff: AiOutlineDiff,
  FileSync: AiOutlineFileSync,
  Warning: AiOutlineWarning,

  EyeOpen: AiOutlineEye,
  EyeClose: AiOutlineEyeInvisible,
  AddBulk: BiLayerPlus,

  MinusSquare: AiOutlineMinusSquare,
  PlusSquare: AiOutlinePlusSquare,
  Stop: AiOutlineStop,

  Process: VscServerProcess,
  ArrowRight: AiOutlineArrowRight,
  ArrowLeft: AiOutlineArrowLeft,

  PlayMusic: BsPlayCircle,
  StopMusic: BsStopCircle,
  Sound: AiOutlineSound,
  Checked: AiOutlineCheck,

  DollarSign: AiOutlineDollar,
  LockOpen: HiOutlineLockOpen,
  LockClose: HiOutlineLockClosed,

  TrendUp: IoTrendingUpOutline,
  TrendDown: IoTrendingDownOutline,
  Robot: FaRobot,
  CreateNew: VscGitPullRequestCreate,

  Regenerate: FiRefreshCcw,
  Minus: AiOutlineMinus,
  CheckList: GoChecklist,
  TFN: AiOutlineDeploymentUnit,

  AudioTranscript: ImFileMusic,
  Merge: AiOutlineGroup,
  RefreshFailed,
  ExpiredTime: AiOutlineFieldTime,
  Shopping: AiOutlineShopping,
  Referral: AiOutlineUserSwitch,

  Route: SiReactrouter,
  ResponderV2: BsDiagram3,

  Gem: FaRegGem,
  AudioSpintax,

  Dot: BsDot,
  Slash: CgFormatSlash,
  Helper: AiOutlineExclamationCircle,

  Moon: MoonIcon,
  Sun: SunIcon,
  Archive: GoArchive,
  Tips: FcIdea,

  RedirectTo: IoArrowRedoOutline,
  Ban: FaBan,
  Shortcode: TfiShortcode,
  CheckCircle: FaCheckCircle,
  Filter: MdOutlineManageSearch,
  Audio: LuAudioWaveform,
  ErrorCircle: MdError,
  FolderInfo: RiFolderInfoLine,
  Reply: MdReply,
  Clicker: LuMousePointerClick,
  Convertor: SiConvertio,
  Caller: BiSolidPhoneCall,
  Split: Split,
  Release: FaTelegramPlane,
};

export { CommonIcons };
